import Toast from '@loggi/components/src/one/toast';
import React from 'react';

const showNotificationMessage = (
  notificationMessage,
  notificationType,
  snackbar
) => {
  snackbar(notificationMessage, {
    content: (key, message) => (
      <Toast id={key} message={message} type={notificationType} />
    )
  });
};

export default showNotificationMessage;
